import { UiSystem } from './System/uiSystem'
import { Animation } from './System/animation'
import { GravityGrid } from './System/gravityGrid';
import { StarCategories } from './Objects/star';
import { RealPlayer } from './Player/realPlayer';
import { PauseUI } from './Ui/pause';
import { PlayUI } from './Ui/play';
import { startSize } from './Objects/star';
// import { onlineMap } from './Map/onlineMap';
import { LocalMap } from './Map/localMap';
import { TileMap } from './Map/tileMap';
import { IntroUI } from './Ui/intro';
import { Ad } from './Ui/ad';

// Improve dive function to reproduce planet attraction effect
// Faire étoile filante plutôt que point blanc
// Tableau de récap à la fin
// Create particle in show/hide to avoid creating 100 particleSystem
// Use Saved Star and avoid checkactivemeshes
// Add star style to custom and make people pay for it
// Tu deviens une supernova et un trou noir quand tu est trop gros comme ça ça donne un objectif pour continuer à grossir
// Faire annonce forum babylonjs

export interface GameInterface {
    canvas?: HTMLCanvasElement,
}

export class GameEngine {

    system: UiSystem;
    animation: Animation;

    gravityGrid: GravityGrid;
    tileMap: TileMap;
    localMap: LocalMap;
    realPlayer: RealPlayer;
    pauseUI: PauseUI;
    playUI: PlayUI;
    ad: Ad;
    // onlineMap: onlineMap;

    constructor() {
        const canvas = document.getElementById('gameCanvas') as HTMLCanvasElement;
        this.system = new UiSystem(canvas);
        this.system.optimize();
        this.animation = new Animation(this.system.animationManager);

        let intro = new IntroUI(this.system);
        intro.hideAnim();

        this.gravityGrid = new GravityGrid(this.system);
        this.tileMap = new TileMap(this.system, this.gravityGrid);
        this.localMap = new LocalMap(this.system, this.gravityGrid, this.tileMap);
        // this.onlineMap = new onlineMap(this.tileMap);
        // this.onlineMap.onLeave = () => {
        //     this.gameOver();
        // }

        this.realPlayer = new RealPlayer(this.system, this.gravityGrid, this.tileMap);
        this.realPlayer.setMoving(false);
        this.realPlayer.onDied = () => {
            this.gameOver();
        };

        this.tileMap.setPlayerToFollow(this.realPlayer);
        this.tileMap.addStar(this.realPlayer);

        
        this.ad = new Ad();
        this.playUI = new PlayUI(this.system, this.realPlayer, this.tileMap);
        this.pauseUI = new PauseUI(this.system, this.realPlayer, this.playUI);
        this.pauseUI.onStart = (mode: 'local' | 'online') => {
            // if (mode == 'online') this.joinGameServer();
            // else this.joinGameLocal();
            this.joinGameLocal();
        };
        
        this.system.scene.freezeActiveMeshes();
        this.system.launchRender();
        this.system.setSky(0);
        this.realPlayer.show();
        this.realPlayer.setSize(startSize);
        this.realPlayer.setCategory(StarCategories[0], true);
        setTimeout(() => {
            this.pauseUI.checkNebula();
            this.pauseUI.showAnim();
        }, 2000);
        this.system.soundManager.load();
    }
    
    gameOver() {
        this.playUI.hideAnim();
        this.tileMap.checkPlayerAndRessources(false);
        setTimeout(() => {
            this.system.soundManager.play('dead');
            this.localMap.eraseAllIas();
            this.tileMap.eraseAllEntity();
            this.realPlayer.restart();
            this.ad.show();
            setTimeout(() => {
                this.pauseUI.showAnim();
            }, 2000);
        }, 4000);
    }

    gameStart() {
        this.system.soundManager.play('play');
        this.system.checkMobile();
        this.system.checkActiveMeshes();
        this.pauseUI.hideAnim(() => {
            this.playUI.showAnim();
        });

        this.realPlayer.setMoving(true);
        this.realPlayer.removeAllPlanets();
        

        // In order to test
        setTimeout(() => {
            // this.gameOver();
            // this.localMap.playerBlackHole(this.realPlayer)
        }, 3000);
    }
    
    joinGameLocal() {
        this.gameStart();
        this.tileMap.checkPlayerAndRessources(true);
        this.tileMap.addStar(this.realPlayer);
    }
    
    // joinGameServer() {
    //     this.onlineMap.join((newRoom) => {
    //         this.gameStart();
    //         this.tileMap.checkPlayerAndRessources(true);
    //         this.realPlayer.key = this.onlineMap.sessionId;
    //         this.tileMap.addStar(this.realPlayer);
    //     });
    // }
}

new GameEngine();
